"use client";

import { useTransition } from "react";
import { useRouter } from "next/navigation";
import { useLocale } from "next-intl";

import type { Locale } from "@/i18n/request";

export function AuthLangToggle() {
  const locale = useLocale();
  const router = useRouter();
  const [pending, startTransition] = useTransition();

  async function toggle(next: Locale) {
    if (next === locale || pending) return;
    try {
      const res = await fetch("/api/locale", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ locale: next }),
      });
      if (res.ok) startTransition(() => router.refresh());
    } catch { /* silent */ }
  }

  return (
    <div className="flex overflow-hidden rounded-full border border-white/15 bg-white/5 backdrop-blur-sm">
      {(["id", "en"] as const).map((code) => (
        <button
          key={code}
          type="button"
          disabled={pending}
          onClick={() => toggle(code)}
          className={`px-3 py-1.5 text-xs font-bold uppercase transition-colors disabled:opacity-50 ${
            locale === code
              ? "bg-primary text-white"
              : "text-white/50 hover:text-white/80"
          }`}
        >
          {code === "id" ? "🇮🇩 ID" : "🇬🇧 EN"}
        </button>
      ))}
    </div>
  );
}
